module.exports = __webpack_public_path__ + "static/media/taconnectlogotsat.77455531.png";